<template>
    <div>
        <v-row no-gutters class="hidden-sm-and-down">
            <v-col class="header" cols="12">
              <span>[id: {{ poll.idMedicionAsignada }}]</span><span>{{ poll.medicionTO.name }} - {{ poll.medicionTO.code }}</span>
            </v-col>
            <v-col class="pa-2 col-sm-12 col-md-8 col-lg-9" align="center">
                <RomaPdfBtnZoom/>
                <RomaPDF v-if="!loading" :pdfDoc="`${urlBase}/${idMedicion}`"></RomaPDF>
                <RomaWait :message="message" v-if="loading"></RomaWait>
            </v-col>
            <v-col class="bar-vertical col-md-4 col-lg-3 hidden-sm-and-down">
                <RomaBarLateralPoll v-if="!loading"></RomaBarLateralPoll>
                <RomaWait :message="message" v-if="loading"></RomaWait>
            </v-col>
        </v-row>

        <div class="hidden-md-and-up" v-if="!getPollDone">
            <RomaPDF v-if="!loading" :pdfDoc="`${urlBase}/${idMedicion}`"></RomaPDF>
            <RomaWait :message="message" v-if="loading" class="margin-50"></RomaWait>
            <RomaHorizontalPoll v-if="!loading" />
        </div>
        
        <RomaDonePoll v-if="getPollDone" class="done hidden-md-and-up"></RomaDonePoll>
    </div>
</template>

<script>
import RomaBarLateralPoll from "@/components/poll/RomaBarLateralPoll";
import RomaPDF from "@/components/poll/RomaPDF";
import {mapActions, mapGetters} from "vuex";
import RomaWait from "../commons/RomaWait";
import RomaHorizontalPoll from "../mobile/RomaHorizontalPoll";
import RomaDonePoll from "./RomaDonePoll";
import RomaPdfBtnZoom from "../commons/pdf/RomaPdfBtnZoom";
export default {
  name: "RomaPoll",
  data() {
      return {
          loading: true,
          idMedicion: 0,
          loadingPdf: true,
          message: null,
          urlBase:  null
      }
  },
  mounted() {
      this.urlBase = process.env.VUE_APP_ROMA_ENCUESTA_PDF_URL;
      this.idMedicion = this.poll.medicionTO.idMedicion;
      setTimeout(() => this.load(), 5000);
      this.message = "Cargando información por favor espere...";
  },
    components: {
        RomaBarLateralPoll,
        RomaPDF,
        RomaWait,
        RomaHorizontalPoll,
        RomaDonePoll,
        RomaPdfBtnZoom
  },
  computed: {
    ...mapGetters({
      poll: "getPoll",
      getPollDone: "getPollDone"
    })
  },
    methods: {
        ...mapActions({
            setEnablePdfPoll: "setEnablePdfPoll"
        }),

        load() {
            this.setEnablePdfPoll({ enablePollMobile: true });
            this.loading = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
  height: 56px;
  background: #3a8fce 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #0000001c;
  opacity: 1;
  width: 100%;
  line-height: 56px;
  span:nth-child(1) {
    margin-left: 70px;
    color: #70C1FF;
    font-family: Medium, "Cabin", sans-serif;
    font-size: 18px;
    opacity: 1;
  }
    span:nth-child(2) {
        margin-left: 10px;
        color: #ffffff;
        font-family: Medium, "Cabin", sans-serif;
        font-size: 18px;
        opacity: 1;
    }
}
.bar-vertical {
  background: #ffffff;
  height: 180vh;
  /*width: 28%;*/
  /*max-width: 28%;*/
  /*min-width: 28%;*/
  float: right;
  right: 0 !important;
  top: 56px;
  /*margin-left: 70px;*/
}

.card-content-poll {
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 6px 6px #0000001c;
  border-radius: 22px;
  opacity: 1;
  /*width: 80%;*/
  padding: 15px 5px;
  height: 190vh;
}

.margin-50 {
    margin-top: 35vh;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
}

</style>
